import { Component, type ErrorInfo, type ReactNode } from "react";
import { Typography } from "antd";
import { audioMessage as message } from "@components/Common/Notifications/audioMessage";
import { WarningOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface Props {
  widgetId: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class WidgetErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[Widget ${this.props.widgetId}] render error:`, error, info.componentStack);
    message.error("A widget failed to render. Please try reloading the dashboard.");
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: 8,
            padding: 16,
            color: "#999",
          }}
        >
          <WarningOutlined style={{ fontSize: 24, color: "#faad14" }} />
          <Text type="secondary" style={{ fontSize: 12, textAlign: "center" }}>
            Something went wrong displaying this widget.
          </Text>
        </div>
      );
    }
    return this.props.children;
  }
}
